const TokenKey = 'HL_HIKENS'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

const refresh_TokenKey = 'LH-HHHHOP'
export function getrefresh_Token() {
  return localStorage.getItem(refresh_TokenKey)
}

export function setrefresh_Token(token) {
  return localStorage.setItem(refresh_TokenKey, token)
}

export function removerefresh_Token() {
  return localStorage.removeItem(refresh_TokenKey)
}


// 将过期时间写入Storage
const expiresAtKey = 'ExpiresAtsssss'

export function getExpires() {
  return localStorage.getItem(expiresAtKey) 
}

export function setExpires(expiresAt) {
  return localStorage.setItem(expiresAtKey, expiresAt)
}

export function removeExpires() {
  return localStorage.removeItem(expiresAtKey)
}

// userInfo
const userInfoKey = 'userstuff'

export function getuserInfo() {
  return localStorage.getItem(userInfoKey) 
}

export function setuserInfo(data) {
  return localStorage.setItem(userInfoKey, data)
}

export function removeuserInfo() {
  return localStorage.removeItem(userInfoKey)
}

// order-storage
const orderKey = 'orderKeya'

export function getOrder() {
  return sessionStorage.getItem(orderKey) 
}

export function setOrder(data) {
  return sessionStorage.setItem(orderKey, data)
}

export function removeOrder() {
  return sessionStorage.removeItem(orderKey)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js